import { render, staticRenderFns } from "./MiddleCategory.vue?vue&type=template&id=b6aa98e0&scoped=true&"
import script from "./MiddleCategory.vue?vue&type=script&lang=js&"
export * from "./MiddleCategory.vue?vue&type=script&lang=js&"
import style0 from "./MiddleCategory.vue?vue&type=style&index=0&id=b6aa98e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6aa98e0",
  null
  
)

export default component.exports